/**
 * Task extension properties
 */ export var TaskExtensionProperties;
(function(TaskExtensionProperties) {
    TaskExtensionProperties["copilot"] = "copilot";
    TaskExtensionProperties["mars_planner_microsoft_CopilotProperties"] = "mars_planner_microsoft_CopilotProperties";
    TaskExtensionProperties["mars_planner_microsoft_LoopDetails"] = "mars_planner_microsoft_LoopDetails";
})(TaskExtensionProperties || (TaskExtensionProperties = {}));
